<template>
  <KeepAlive>
    <v-app>
      <RegisterAppbar></RegisterAppbar>
      <v-main>
        <v-container class="text-N700 d-flex justify-center" fluid>
          <v-sheet :width="global ? '100%' : 500" :class="global ? 'mx-4' : ''">
            <router-view></router-view>
          </v-sheet>
        </v-container>
      </v-main>
    </v-app>
  </KeepAlive>
</template>

<script>
import RegisterAppbar from '@/components/RegisterAppbar.vue'

export default {
  name: 'RegisterView',
  computed: {
    global() {
      return this.$route.path.includes('/order/') ? true : false
    },
  },
  components: {
    RegisterAppbar,
  },
}
</script>
